import { saveAs } from "file-saver";
import { ACCEPTED_FILE_EXTENSIONS_CASE } from "src/constants";
import ExcelJS from 'exceljs';
import { CaseListingType, ExcelSheetCaseProps, ExcelSheetHeader } from "src/pages/dashboard/types";

export const downloadZipFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/x-zip-compressed;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};

export const downloadPdfFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/pdf;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};
export const downloadExcelFile = (base64Data: string, fileName: string) => {
  fetch(`data:applicatiaon/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`)
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
};

export const downloadFileAccordingToExtension = (base64Data: string, fileName: string) => {
  const fileExtension = `.${fileName.split(".").pop()}`;
  if (fileExtension === ".xlsx") downloadExcelFile(base64Data, fileName);
  else
    fetch(`data:${ACCEPTED_FILE_EXTENSIONS_CASE[fileExtension]};base64,${base64Data}`)
      .then(res => res.blob())
      .then((blob) => {
        saveAs(blob, fileName);
      });
};

export const exportToExcel = (jsonData: CaseListingType[], fileName: string) => {
  // Step 1: Convert JSON to worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  const topRow = worksheet.addRow([
    "Case ID Number",
    "Rx Submitted",
    "RX Shipped",
    "Patient Name",
    "Patient DOB",
    "Physician Name",
    "Pharmacy Name",
    "Case Status"
  ]);
  topRow.font = { bold: true, size: 14 };
  topRow.alignment = { horizontal: 'center' };

  const parsedJSONData: ExcelSheetCaseProps[] = [];
  jsonData.forEach((kase: CaseListingType) => {
    parsedJSONData.push({
      "Case ID Number": kase.id.toString(),
      "Rx Submitted": kase.created_at,
      "RX Shipped": kase.rx_shipped,
      "Patient Name": kase.patient.firstlastname,
      "Patient DOB": kase.patient.dob,
      "Physician Name": kase.doctor.firstlastname,
      "Pharmacy Name": kase.pharmacy || "",
      "Case Status": kase.status_name,
    })
    worksheet.addRow(Object.values({
      "Case ID Number": kase.id,
      // "Review Type": kase.review_type,
      "Rx Submitted": kase.created_at,
      "RX Shipped": kase.rx_shipped,
      "Patient Name": kase.patient.firstlastname,
      "Patient DOB": kase.patient.dob,
      "Physician Name": kase.doctor.firstlastname,
      "Pharmacy Name": kase.pharmacy || "",
      "Case Status": kase.status_name,
    }));
  });

  // Set column widths to fit content
  [
    "Case ID Number",
    "Rx Submitted",
    "RX Shipped",
    "Patient Name",
    "Patient DOB",
    "Physician Name",
    "Pharmacy Name",
    "Case Status"
  ].forEach((header: string, i: number) => {
    const maxLength = Math.max(
      header.length,
      ...parsedJSONData.map((item: ExcelSheetCaseProps) => String(item[header as ExcelSheetHeader] || '').length)
    );
    worksheet.getColumn(i + 1).width = maxLength + 5; // +2 for padding
    worksheet.getColumn(i + 1).alignment = { horizontal: 'center' };
  });

  workbook.xlsx.writeBuffer().then((buffer: any) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
  
    saveAs(blob, fileName);
  });
};
